module.exports = __webpack_public_path__ + "img/alphera-logo.88d30780.png";